import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=54e11f06&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=js"
export * from "./FeedbackList.vue?vue&type=script&lang=js"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=54e11f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e11f06",
  null
  
)

export default component.exports